//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    event_id: number;
    market_id: number;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/events/{event_id}/markets/{market_id}/liabilities/multiples -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    overround: t.union([t.null, t.undefined, t.number]),
    selections: t.array(t.interface({
        id: t.string,
        name: t.union([t.null, t.undefined, t.string]),
        price: t.union([t.null, t.undefined, t.interface({
            d: t.number,
            f: t.string,
        })]),
        result: t.union([t.null, t.undefined, t.interface({
            place: t.union([t.null, t.undefined, t.number]),
            type: t.string,
        })]),
        sgl: t.interface({
            expPayout: t.number,
            netPayout: t.number,
            openBetsNum: t.number,
            openStakes: t.number,
            rumLines: t.number,
            rumPayout: t.number,
            rumStakes: t.number,
            totalBetsNum: t.number,
            totalStakes: t.number,
            totalStakesPercent: t.number,
        }),
        spPrice: t.union([t.null, t.undefined, t.interface({
            d: t.number,
            f: t.string,
        })]),
    })),
    sgl: t.union([t.null, t.undefined, t.interface({
        bets: t.number,
        placeStakes: t.number,
        stakes: t.number,
        totalCashOutBets: t.number,
        totalCashOutPayout: t.number,
        totalCashOutStakes: t.number,
    })]),
});
export type Response200Type = {
    overround?: null | undefined | number;
    selections: Array<{
        id: string;
        name?: null | undefined | string;
        price?: null | undefined | {
            d: number;
            f: string;
        };
        result?: null | undefined | {
            place?: null | undefined | number;
            type: string;
        };
        sgl: {
            expPayout: number;
            netPayout: number;
            openBetsNum: number;
            openStakes: number;
            rumLines: number;
            rumPayout: number;
            rumStakes: number;
            totalBetsNum: number;
            totalStakes: number;
            totalStakesPercent: number;
        };
        spPrice?: null | undefined | {
            d: number;
            f: string;
        };
    }>;
    sgl?: null | undefined | {
        bets: number;
        placeStakes: number;
        stakes: number;
        totalCashOutBets: number;
        totalCashOutPayout: number;
        totalCashOutStakes: number;
    };
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffGetLiabilitiesMultiplesRequest"
 */
export const openapi_proxy_staff_get_liabilities_multiples = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/events/${params.event_id}/markets/${params.market_id}/liabilities/multiples${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffGetLiabilitiesMultiplesParamsType = ParamsType;

export type OpenapiProxyStaffGetLiabilitiesMultiplesResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffGetLiabilitiesMultiplesResponse200Type = Response200Type;

export const openapiProxyStaffGetLiabilitiesMultiplesRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffGetLiabilitiesMultiplesResponseType> => {
    const response = await openapi_proxy_staff_get_liabilities_multiples(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffGetLiabilitiesMultiplesRequest - unhandled response ${response.status}`);
};

